import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppsDashboard from "./scenes/AppsDashboard.js";
import Admin from "./scenes/Admin.js";
import Background from "./animations/Background.js";
import "../css/forge.scss";
import "../css/background.scss";
import "../css/animations.scss";
import NavigationMenu from "./NavigationMenu.js";
import Intro from "./animations/Intro.js";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {ContextMenuHook} from "../hooks/ContextMenuHook.js";
import LoginPopup from "./elements/navigation/LoginPopup.js";

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#FF4D00',
        },
        background: {
            paper: '#303030',
            default: '#1c1c1c',
        },
    },
});

export default function App() {
    return(
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <ContextMenuHook>
                <Background/>
                <Intro/>
                <Router>
                    <NavigationMenu/>
                    <Routes>
                        <Route path="/" element={<AppsDashboard/>} />
                        <Route path="/admin" element={<Admin/>} />
                    </Routes>
                </Router>
            </ContextMenuHook>
        </ThemeProvider>
    );
}